<template>
	<v-card>
		<v-card-title>
			<h2>Typy projektów w naborach</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="ml-3 mt-3 mb-3">Dodaj typ projektu</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited()">Edycja typu projektu</span>
					<span class="headline" v-else> Dodaj nowy typ projektu</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm12 md12>
								<v-text-field
									browser-autocomplete="off"
									v-model="editedItem.type"
									label="Typ projektu"
									aria-label="project type"
									for="agency-contest-types-view-type"
									id="agency-contest-types-view-type"
								></v-text-field>
							</v-flex>
							<v-flex xs6 sm6 md6>
								<v-flex xs5 sm5 md5>
									<v-text-field v-model="editedItem.abbreviation" label="Skrót nazwy"
										aria-label="abbreviation" browser-autocomplete="off"
										placeholder="np. W"></v-text-field>
								</v-flex>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<egranty-table :items="agencyContestTypes"
			:headers="contestTypesHeaders"
			:table-name="''"
			:row-actions="actions"
			@edit="editItem"
			@delete="deleteItem"
		></egranty-table>
	</v-card>
</template>

<script>
	import EgrantyTable from "../../../genericComponents/EgrantyTable";
	import {AgencyProjectType} from "../../../api/generated/AgencyProjectType";

	export default {
		name: "AgencyProjectTypesView",
		components: {EgrantyTable},

		data() {
			return {
				dialog: false,
				edit: false,
				agencyContestTypes: [],
				contestTypesHeaders: [
					{text: "Typ projektu", value: "type"},
					{text: "Skrót nazwy", value: "abbreviation"},
				],
				actions: [
					{name: "edit", icon: "edit"},
					{name: "delete", icon: "delete"},
				],
				editedItem: {},
			};
		},

		mounted() {
			this.update();
		},

		methods: {

			isEdited() {
				return this.edit;
			},

			update() {
				AgencyProjectType.get(this, successResponse => {
						this.agencyContestTypes = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać listy typów projektów", errorResponse);
					});
			},

			editItem(item) {
				this.editedItem = Object.assign({}, item);
				this.edit = true;
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć typ projektów?", {
					icon: 'delete',
					title: 'Usuwanie typu projektów',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyProjectType.delete(this, item.id, successResponse => {
									this.$messagesBus.$emit("success", "Typ projektów został pomyślnie usunięty", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.edit = false;
				this.editedItem = {};
			},

			save() {
				let item = {};
				item.type = this.editedItem.type;
				item.id = this.editedItem.id;
				item.abbreviation = this.editedItem.abbreviation;
				item.deleted = this.isEdited() ? this.editedItem.deleted : false;
				AgencyProjectType.put(this, item, successResponse => {
						this.$messagesBus.$emit("success", "Typ projektów został pomyślnie " +
							(this.isEdited() ? "zapisany" : "dodany"), successResponse);
						this.agencyContestTypes.push(successResponse);
						this.update();
						this.close();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się " +
							(this.isEdited() ? "zapisać" : "dodać") + " typu projektów", errorResponse);
					});
			},
		},
	};
</script>

<style scoped>
	
</style>
